// extracted by mini-css-extract-plugin
export default {"location":"locations-module--location--nZtdW","locations":"locations-module--locations--4SCx2","locationsCarousel":"locations-module--locations-carousel--8eaSp"};